import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import { NodeData } from 'store';

@Component({
    mounted() {
        this.checkRoute();
    }
})
export default class NavigationItem extends Vue {
    @Prop({
        default() {
            return {
                id: '',
                name: '',
                title: '',
                path: '',
                children: [],
                hidden: true,
                versionValidator: {
                    versionFrom: 0,
                    versionTo: 0
                }
            };
        }
    })
    readonly item!: NodeData;

    @Prop({
        default: false
    })
    isAvailable!: boolean;

    @Watch('$route')
    onRouteChange() {
        window.scrollTo(0, 0);

        this.checkRoute();
    }

    /**
     * Check if current url is equal component path, if yes trigger store event with self id
     */
    checkRoute() {
        if (this.item && this.item.path && this.item.path === this.$route.path) {
            this.$emit('navigation:activated', this.$props.item.id);
        }
    }
}
